import React from 'react'

import PropTypes from 'prop-types'

const FirstParameterAdjust = ({ field, label, rightLabel, translate, setValueToField, index }) => (
  <tr className={'mobiItem'}>
    <td>{translate(label)}</td>
    <td>
      <input
        value={field.value}
        onChange={(e) => {
          setValueToField(index, e.target.value.replace(/\D/g, ''))
        }}
        style={{height: '45px', width: '75px', marginRight: '16px'}}
        placeholder={'0'}
        className='form-control'
        type='input'

      />
      <span className='margin-left-extra-small'>{translate(rightLabel)}</span>
    </td>
  </tr>
)

FirstParameterAdjust.propTypes = {
  field: PropTypes.object,
  label: PropTypes.string,
  rightLabel: PropTypes.string,
  translate: PropTypes.func,
  setValueToField: PropTypes.func,
  index: PropTypes.number
}
export default FirstParameterAdjust
